import { signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { effect, inject } from '@angular/core';
import { BaseState, withCrudOperations } from '../crud.state';
import { Workspace } from '../../models/workspace';
import { withWorkspaceSelectors } from './workspace.selectors';
import { WorkspaceService } from '../../services/workspace.service';
import { withLogging } from '../features/logger.feature';
import { ActiveUserStore } from '../user/active-user.state';

export type WorkspaceState = BaseState<Workspace>;

export const initialState: WorkspaceState = {
  items: {},
  loading: false,
  initialized: false,
  itemsLoaded: false,
  selectedId: '',
  selection: [],
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'Workspace',
  entityLabel: 'Arbeitsbereich',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
  events: {
    add: ['writeWorkspaceToEntities'],
    update: ['writeWorkspaceToEntities'],
  },
};

export const WorkspaceStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<Workspace>(WorkspaceService),
  withLogging(initialState.entityType),
  withWorkspaceSelectors(),
  withMethods(store => ({})),
  withHooks({
    onInit(store, activeUserStore = inject(ActiveUserStore)) {
      // See category.state.ts for why this watches commune reactively
      // instead of firing once at construction time.
      effect(
        () => {
          if (activeUserStore.commune()) {
            store.loadAllItemsByPromise();
          }
        },
        { allowSignalWrites: true }
      );
    },
  })
);
